import * as React from "react";
import * as Immutable from "immutable";
import { ReadOnlyFormGroup } from "components/common";
import SectionComponent from "components/common/Section/SectionComponent";
import EditLinkButton from "./EditLinkButton";
import { STEP_KEY as USER_SYNC_KEY } from "../BackendWizard/UserSyncStep";
const rolesList = (defaultRolesIds, roles) => {
  const defaultRolesNames = defaultRolesIds.map(
    (roleId) => {
      var _a, _b;
      return (_b = (_a = roles.find((role) => role.id === roleId)) == null ? void 0 : _a.name) != null ? _b : "Role not found";
    }
  );
  return defaultRolesNames.join(", ");
};
const UserSyncSection = ({ authenticationBackend, roles, excludedFields = {} }) => {
  const {
    userSearchBase,
    userSearchPattern,
    userNameAttribute,
    userFullNameAttribute,
    userUniqueIdAttribute,
    emailAttributes
  } = authenticationBackend.config;
  const { defaultRoles = Immutable.List(), defaultUserTimezone } = authenticationBackend;
  return /* @__PURE__ */ React.createElement(
    SectionComponent,
    {
      title: "User Synchronization",
      headerActions: /* @__PURE__ */ React.createElement(EditLinkButton, { authenticationBackendId: authenticationBackend.id, stepKey: USER_SYNC_KEY })
    },
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Search Base DN", value: userSearchBase }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Search Pattern", value: userSearchPattern }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Name Attribute", value: userNameAttribute }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Full Name Attribute", value: userFullNameAttribute }),
    !excludedFields.emailAttributes && /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Email Attribute", value: emailAttributes.join(",") }),
    !excludedFields.userUniqueIdAttribute && /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "ID Attribute", value: userUniqueIdAttribute }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Default Roles", value: rolesList(defaultRoles, roles) }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Default User Time Zone", value: defaultUserTimezone || "Browser's time zone" })
  );
};
export default UserSyncSection;
